export default __webpack_public_path__ + "static/media/tab_account_active.3f3a0c33.svg";